<div *ngIf="this.isDebugMode" class="d-flex justify-content-end perf-toolbar">
  <performance-metrics></performance-metrics>
</div>
